import React, {useMemo} from 'react';
import dynamic from 'next/dynamic';

/**
 * 打卡营后台设置富文本编辑器
 * @constructor
 */
const EditorNotSSR = dynamic(() => import('@digit-fe/digit-editor-new'), {
  ssr: false,
});
const ReadOnlyEditor = (props: any) => {
  const content = props?.content;
  const parseContent = useMemo(() => {
    if (typeof content === 'string') {
      try {
        return JSON.parse(content);
      } catch (e) {
        return '';
      }
    }
    if (typeof content === 'object') {
      return content;
    }
    return '';
  }, [content]);
  return (
    <EditorNotSSR
      editable={false}
      titleProps={{showTitle: false}}
      catalogProps={{showCatalog: false}}
      content={parseContent}
      className={props.className}
      style={props.style}
      onChange={props.onChange}
    />
  );
};

export default ReadOnlyEditor;
